import { render, staticRenderFns } from "./ShowTournament.vue?vue&type=template&id=2a3fe528&scoped=true"
import script from "./ShowTournament.vue?vue&type=script&lang=js"
export * from "./ShowTournament.vue?vue&type=script&lang=js"
import style0 from "./ShowTournament.vue?vue&type=style&index=0&id=2a3fe528&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a3fe528",
  null
  
)

export default component.exports